import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { ServicesSection } from './components/ServicesSection';
import { SectorsSection } from './components/SectorsSection';
import { NetworkSection } from './components/NetworkSection';
import { TeamSection } from './components/TeamSection';
import { DueDiligenceSection } from './components/DueDiligenceSection';
import { ValuePropsSection } from './components/ValuePropsSection';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';

function App() {
  return (
    <div className="min-h-screen bg-white text-zinc-900 font-sans selection:bg-amber-500 selection:text-white">
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <SectorsSection />
        <NetworkSection />
        <TeamSection />
        <DueDiligenceSection />
        <ValuePropsSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}

export default App;